import { TagsInput } from "@arcadeai/design-system/components/ui/molecules/tags-input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { Control } from "react-hook-form";
import { scopeTokenSchema, type UserSourceCreateRequest } from "../../types";

type ScopesFormFieldProps = {
  control: Control<UserSourceCreateRequest>;
};

export function ScopesFormField({ control }: ScopesFormFieldProps) {
  return (
    <FormField
      control={control}
      name="scopes"
      render={({ field }) => {
        const values: string[] = field.value ?? [];
        return (
          <FormItem>
            <FormLabel>
              Scopes
              <span className="text-destructive"> *</span>
            </FormLabel>
            <FormControl>
              <TagsInput
                isDuplicate={(incoming, stored) =>
                  incoming === stored && "Scope already added"
                }
                onChange={field.onChange}
                placeholder="Add a scope and press Enter…"
                validateValue={(trimmed) => {
                  const result = scopeTokenSchema.safeParse(trimmed);
                  return result.success
                    ? {}
                    : { error: result.error.issues[0].message };
                }}
                values={values}
              />
            </FormControl>
            <FormDescription>
              OIDC scopes requested from the upstream identity provider.
              Defaults to{" "}
              <code className="font-mono text-xs">openid profile email</code>.
            </FormDescription>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
}
